import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import type { CurrentPage } from '../../App';

interface FloorPlanGraphFormProps {
  onNavigate: (page: CurrentPage, associatedId?: string) => void;
  floorPlanId?: string;
}

const FloorPlanGraphForm: React.FC<FloorPlanGraphFormProps> = ({ onNavigate, floorPlanId }) => {
  useEffect(() => {
    if (floorPlanId) {
      console.log('FloorPlanGraphForm received floorPlanId:', floorPlanId);
      // Fetch data related to this floorPlanId or perform other actions
    }
  }, [floorPlanId]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header
        className="bg-gray-100 border-b border-gray-200 shadow-sm sticky top-0 z-40 flex-shrink-0"
      >
        <div className="w-full px-4 py-3 flex items-center justify-between">
          <button
            onClick={() => onNavigate({ page: 'retrofit' })}
            title="Back to Retrofit Hub"
            className="p-2 rounded-md text-gray-700 hover:bg-gray-200 transition-colors"
          >
            <ArrowLeft size={22} />
          </button>
          <h1 className="text-lg font-semibold text-gray-800">
            Floor Plans Graph Form
          </h1>
          <div className="w-10"></div> {/* Spacer */}
        </div>
      </header>

      {/* Content - TODO: Add form fields based on PDF */}
      <main className="flex-1 p-4 sm:p-6 lg:p-8">
        {floorPlanId && <p>Editing for Floor Plan ID: {floorPlanId}</p>}
        <p className="text-gray-600">Form content for Floor Plans Graph will go here...</p>
        {/* Example: <Input label="Field 1" /> */}
      </main>
    </div>
  );
};

export default FloorPlanGraphForm; 